import { useEffect, useRef } from 'react'

const BLOCKED_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

const isTypingContext = (): boolean => {
  const el = document.activeElement
  if (!el) return false
  if (BLOCKED_TAGS.has(el.tagName)) return true
  if (el instanceof HTMLElement && (el.isContentEditable || el.getAttribute('contenteditable') === 'true')) return true
  return false
}

const useKeyboardShortcut = (key: string, callback: () => void): void => {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key !== key) return
      if (!e.metaKey && !e.ctrlKey) return
      if (isTypingContext()) return
      e.preventDefault()
      callbackRef.current()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [key])
}

export default useKeyboardShortcut
